import React from 'react';

import {
  init,
  composeAgents,
  ErrorBoundary as DafitiErrorBoundary,
} from '@dafiti/observability-sdk';

import type { Instrumentation } from '@dafiti/observability-sdk';

// eslint-disable-next-line import/no-unresolved
import { DatadogAdapter } from '@dafiti/observability-sdk/datadog';
import { useConfig } from './ConfigProvider';

let tracer: Instrumentation | null = null;

export function useTracer(): Instrumentation | null {
  const config = useConfig();

  if (!config) return null;

  if (tracer) return tracer;

  const agents: Instrumentation[] | null = [];

  if (config.REACT_APP_ENABLE_DATADOG === 'true') {
    const datadog = init(DatadogAdapter, {
      applicationId: config.REACT_APP_DATADOG_APP_ID,
      clientToken: config.REACT_APP_DATADOG_CLIENT_TOKEN,
      env: config.REACT_APP_ENVIRONMENT,
      service: 'login-front',
    });

    agents.push(datadog);
  }

  tracer = composeAgents(...agents);

  return tracer;
}

export const getTracer = () => tracer;

export const ErrorBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const tracer = useTracer();

  if (!tracer) return <>{children}</>;

  return (
    <DafitiErrorBoundary instrumentation={tracer}>
      {children}
    </DafitiErrorBoundary>
  );
};
